import React, { useState, useEffect } from "react";

import { showGrade } from "../../../../../utils/textUtils";

import LevelTab from "./LevelTab";
import GradeTab from "./GradeTab";

const FilteringTab = ({
  levels,
  allStudentList,
  selectedParams,
  setSelectedParams,
}) => {
  const [groupedStudentsByLevel, setGroupedStudentsByLevel] = useState({
    unassigned: { name: "클래스 없음", students: [] },
  });
  const [groupedStudentsByGrade, setGroupedStudentsByGrade] = useState({});
  const [isMobile, setIsMobile] = useState(
    Math.min(window.innerWidth, window.screen.width) <= 768
  );
  useEffect(() => {
    const f = () =>
      setIsMobile(Math.min(window.innerWidth, window.screen.width) <= 768);
    window.addEventListener("resize", f);
    window.addEventListener("orientationchange", f);
    return () => {
      window.removeEventListener("resize", f);
      window.removeEventListener("orientationchange", f);
    };
  }, []);

  const [selectedTab, setSelectedTab] = useState("학급");

  const handleClickStudent = (studentId) => {
    if (selectedParams.studentId === studentId) {
      setSelectedParams({ levelId: null, studentId: null, studentGrade: null });
    } else {
      setSelectedParams({
        studentId,
        levelId: null,
        studentGrade: null,
      });
    }
  };

  const handleClickAllStudentsByLevel = (levelId) => {
    if (selectedParams.levelId === levelId) {
      setSelectedParams({ levelId: null, studentId: null, studentGrade: null });
    } else {
      setSelectedParams({ levelId, studentId: null, studentGrade: null });
    }
  };

  const handleClickAllStudentsByGrade = (studentGrade) => {
    if (selectedParams.studentGrade === studentGrade) {
      setSelectedParams({ levelId: null, studentId: null, studentGrade: null });
    } else {
      setSelectedParams({ levelId: null, studentId: null, studentGrade });
    }
  };

  useEffect(() => {
    const updatedGroupedStudentsByLevel = levels.reduce(
      (acc, level) => {
        acc[level.id] = { name: level.name, students: [] };
        return acc;
      },
      { unassigned: { name: "클래스 없음", students: [] } }
    );
    const updateGroupedStudentByGrade = {};
    for (let i = 1; i <= 12; i++) {
      updateGroupedStudentByGrade[i] = { name: showGrade(i), students: [] };
    }

    allStudentList.forEach((student) => {
      if (student.level_list && student.level_list.length > 0) {
        student.level_list.forEach((level) => {
          updatedGroupedStudentsByLevel[level.id]?.students.push(student);
        });
      } else {
        updatedGroupedStudentsByLevel.unassigned.students.push(student);
      }
      updateGroupedStudentByGrade[student.grade].students.push(student);
    });

    setGroupedStudentsByLevel(updatedGroupedStudentsByLevel);
    setGroupedStudentsByGrade(updateGroupedStudentByGrade);
  }, [levels, allStudentList]);

  const styles = {
    classListContainer: {
      // [모바일 수정] 고정 250px 사이드바가 폰에서 표를 짓눌러 글자가 세로로
      // 붕괴하던 원인의 절반. 폰에선 전폭 카드로 표 위에 놓인다(부모가 column).
      width: isMobile ? "100%" : "250px",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
      border: "1px solid #E6EDEC",
      borderRadius: "18px",
      overflow: "hidden",
      boxShadow: "0 10px 30px -22px rgba(20, 40, 50, .22)",
      alignSelf: "flex-start",
      marginRight: isMobile ? 0 : "16px",
      marginBottom: isMobile ? "12px" : 0,
    },
    classList: {
      listStyle: "none",
      padding: "0px",
      margin: "0px",
      overflow: "auto",
      maxHeight: isMobile ? "220px" : "none",
      WebkitOverflowScrolling: "touch",
    },
  };

  return (
    <div style={styles.classListContainer}>
      <ul style={styles.classList}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            borderBottom: "1.5px solid #0E141B",
          }}
        >
          <div
            style={{
              width: "50%",
              textAlign: "center",
              padding: "12px 10px",
              fontSize: "14px",
              fontWeight: selectedTab === "학급" ? 800 : 600,
              color: selectedTab === "학급" ? "#00A396" : "#7A8490",
              cursor: "pointer",
              boxShadow: "none",
              transition: "color .12s",
            }}
            onClick={(e) => setSelectedTab("학급")}
          >
            {"학급"}
          </div>
          <div
            style={{
              width: "50%",
              textAlign: "center",
              padding: "12px 10px",
              fontSize: "14px",
              fontWeight: selectedTab === "학년" ? 800 : 600,
              color: selectedTab === "학년" ? "#00A396" : "#7A8490",
              cursor: "pointer",
              boxShadow: "none",
              transition: "color .12s",
            }}
            onClick={(e) => setSelectedTab("학년")}
          >
            {"학년"}
          </div>
        </div>
        {selectedTab == "학급" && (
          <LevelTab
            groupedStudents={groupedStudentsByLevel}
            handleClickAllStudents={handleClickAllStudentsByLevel}
            handleClickStudent={handleClickStudent}
            selectedParams={selectedParams}
          />
        )}
        {selectedTab == "학년" && (
          <GradeTab
            groupedStudents={groupedStudentsByGrade}
            handleClickAllStudents={handleClickAllStudentsByGrade}
            handleClickStudent={handleClickStudent}
            selectedParams={selectedParams}
          />
        )}
      </ul>
    </div>
  );
};

export default FilteringTab;
